<script>
import { list } from '@/api/business/crmCustomerContact'
export default {
  components: {},
  props: {
    customerId: {
      type: [String, Number],
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    // 监听customerId变化，当有值时加载options
    customerId: {
      handler(val) {
        if (!val) {
          this.selectedValue = null
          return
        }
        this.initOptions();
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    initOptions() {
      if (!this.customerId) {
        return;
      }

      this.loading = true;
      list({
        customerId: this.customerId
      }).then(res => {
        this.options = res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      this.$emit('change', this.options.find(item => item.id === val))
    },

    querySearch(queryString, cb) {
      var restaurants = this.options;
      console.log('queryString===>', queryString)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.contactName.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    handleSelect(info) {
      this.selectedValue = info.contactName
      this.$emit('change', this.options.find(item => item.id === info.id))
    }
  }
}
</script>

<template>
  <el-autocomplete
    class="inline-input"
    v-model="selectedValue"
    v-bind="$attrs"
    :fetch-suggestions="querySearch"
    placeholder="请输入内容"
    @select="handleSelect"
  >
    <template slot-scope="{ item }">
      <div class="name">{{ item.contactName+"("+item.contactPhone+")" }}</div>
    </template>
  </el-autocomplete>
</template>

<style lang="scss" scoped></style>
